import styled from 'styled-components';

export const TextSectionStyle = styled.div`
  .amondz-form {
    .amondz-input {
      width: 300px;
    }
  }

  .amondz-form-sub-content {
    font-weight: 600;
  }
`;
